<script lang="ts" setup>
import { GpAvatar, GpTag } from '@gportal/uikit';

// TODO: move to panel

withDefaults(
  defineProps<{
    user: {
      avatarUrl: string;
      fullName?: string;
      username?: string;
      email?: string;
      id: string;
    };
    isSessionUser: boolean;
    avatarSize?: 'sm' | 'small' | 'md' | 'medium' | 'lg' | 'large';
  }>(),
  {
    isSessionUser: false,
    avatarSize: 'lg',
  },
);
</script>

<template>
  <div class="tw-m-0 tw-flex tw-flex-wrap tw-items-center tw-p-0 tw-leading-none">
    <div class="tw-relative tw-mr-2">
      <GpAvatar
        :src="user.avatarUrl"
        :alt="user.fullName || user.username || user.id"
        rounded
        :size="avatarSize"
      />

      <GpTag
        v-if="isSessionUser && avatarSize !== 'md'"
        class="tw-absolute -tw-bottom-1 -tw-right-1"
        tag-type="info"
        size="xs"
        label="YOU"
      />
    </div>

    <GpTag v-if="isSessionUser && avatarSize === 'md'" size="xs" label="YOU" tag-type="info" />

    <slot>
      <p class="tw-ml-2">
        {{ user.fullName || user.username }}<br />
        <small>{{ user.email || user.id }}</small>
      </p>
    </slot>
  </div>
</template>
